module.exports = __webpack_public_path__ + "static/media/mallon.placeholder.941dbe25.jpg";